"use client";

/**
 * Separator line component for feature list items
 * Centralized spacing management - maintains spacing without visual fill
 */
export function FeatureSeparator() {
  return (
    <div className="h-0 relative shrink-0 w-full">
      <div className="absolute bottom-0 left-0 right-0 top-[-1px]">
        <div className="h-px w-full" />
      </div>
    </div>
  );
}
